import { AxiosResponse } from 'axios';

import { URLS } from '@/constants';
import { apiSlugSession } from '@/services/session';

import { PaymentOnSellThroughEnrollment } from './models/paymentOnSellThrough';

export async function getPaymentOnSellThroughEnrollment() {
  const response = await apiSlugSession.get<PaymentOnSellThroughEnrollment>(URLS.SELL_THROUGH.ENROLLMENT);

  return response.data;
}

export async function acknowledgePaymentOnSellThroughEnrollment() {
  const response = await apiSlugSession.patch<never, AxiosResponse<PaymentOnSellThroughEnrollment>>(
    URLS.SELL_THROUGH.ACKNOWLEDGE,
  );
  return response.data;
}

type RejectEnrollmentPayload = { text: string };
export async function rejectPaymentOnSellThroughEnrollment({ text }: RejectEnrollmentPayload) {
  const response = await apiSlugSession.patch<RejectEnrollmentPayload, AxiosResponse<PaymentOnSellThroughEnrollment>>(
    URLS.SELL_THROUGH.REJECT,
    { text },
  );
  return response.data;
}

export async function acceptPaymentOnSellThroughTerms() {
  const response = await apiSlugSession.patch<never, AxiosResponse<PaymentOnSellThroughEnrollment>>(
    URLS.SELL_THROUGH.ACCEPT_TERMS,
  );
  return response.data;
}

export async function removePaymentOnSellThroughCompletionMessage() {
  const response = await apiSlugSession.patch<never, AxiosResponse<PaymentOnSellThroughEnrollment>>(
    URLS.SELL_THROUGH.REMOVE_COMPLETION_MESSAGE,
  );
  return response.data;
}

export async function paymentOnSellThroughOptIn() {
  const response = await apiSlugSession.patch<PaymentOnSellThroughEnrollment>(URLS.SELL_THROUGH.OPT_IN);
  return response.data;
}
